import SideBar from "@/components/SidebarPlugin";
import Notify from "@/components/NotificationPlugin";
import GlobalComponents from "./globalComponents";
import GlobalDirectives from "./globalDirectives";
import RTLPlugin from "./RTLPlugin";

import Vuetify from "vuetify";
import ElementUI from "element-ui";
import locale from "element-ui/lib/locale/lang/en"; // 영어 로케일 가져오기

//css assets
import "@/assets/sass/black-dashboard.scss";
import "@/assets/css/nucleo-icons.css";
import "@/assets/demo/demo.css";

// element ui
import "element-ui/lib/theme-chalk/index.css";

// vuetify
import "vuetify/dist/vuetify.min.css";
import "@mdi/font/css/materialdesignicons.css";
export default {
  install(Vue) {
    const vuetify = new Vuetify({
      icons: {
        iconfont: "mdi", // Default - 'mdi'
      },
    });
    Vue.use(Vuetify);
    Vue.prototype.$vuetify = vuetify.framework; // Vuetify 인스턴스 추가
    Vue.use(ElementUI, { locale }); // 기본 언어를 영어로 설정
    Vue.use(GlobalComponents);
    Vue.use(GlobalDirectives);
    Vue.use(SideBar);
    Vue.use(Notify);
    Vue.use(RTLPlugin);
  },
};
